import type { ReactNode } from 'react'

// Icons shown before a section's title, keyed by its managerium section id —
// bristol's cockpit `SECTION_ICONS`. A section without one shows its title alone.
const bank = (
  <>
    <path d='M12 2 2.5 6.75V9h19V6.75L12 2Z' />
    <path d='M4.5 10.5h3v7h-3zM10.5 10.5h3v7h-3zM16.5 10.5h3v7h-3z' />
    <path d='M2.5 19h19v2.5h-19z' />
  </>
)

const SECTION_ICONS: Record<string, ReactNode> = {
  financials: bank,
  // The mock data's id for the same section.
  financial: bank,
  // Person
  customers: (
    <>
      <circle cx='12' cy='7' r='4.5' />
      <path d='M3.5 21v-1.5C3.5 16 7.3 13.5 12 13.5s8.5 2.5 8.5 6V21h-17Z' />
    </>
  ),
  // Triangle, rounded square and circle cluster
  other: (
    <>
      <path d='M2 4.5h8.5l-4.25 7.5L2 4.5Z' />
      <rect x='12.5' y='2' width='9' height='9' rx='2.5' />
      <circle cx='10' cy='16.5' r='5.5' />
    </>
  ),
  // Banknote
  'non-okr-financials': (
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4 5.5h16a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2Zm8 9.75a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5Z'
    />
  ),
}

type SectionIconProps = {
  sectionId: string
  className?: string | undefined
}

export const SectionIcon = ({ sectionId, className }: SectionIconProps) => {
  const icon = SECTION_ICONS[sectionId]
  if (!icon) return null
  return (
    <svg
      className={className}
      viewBox='0 0 24 24'
      fill='currentColor'
      aria-hidden='true'
    >
      {icon}
    </svg>
  )
}
